var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.calculated)?_c('div',{staticClass:"gantogram-container"},[_c('div',{ref:"scrollContainer",staticClass:"gantogram-scroll-container",style:({ height: _vm.totalHeight + _vm.bottomScrollMargin + 'px' }),on:{"scroll":_vm.calculateSidebarLeft}},[_vm._l((_vm.rows),function(row,key){return _c('div',{key:'horizontalLine' + key,class:{
				'gantogram-horizontal-line': !_vm.$vuetify.theme.dark,
				'gantogram-horizontal-line-dark-theme': _vm.$vuetify.theme.dark,
			},style:({
				top: _vm.locations.rows['row' + key].top + _vm.eventHeight * _vm.locations.rows['row' + key].size - 1 + 'px',
				left: _vm.sidebarWidth + 'px',
				width: _vm.dayWidth * _vm.dates.length + 'px',
			})})}),_vm._l((_vm.dates),function(date,key){return _c('div',{key:'verticalLine' + key,class:{
				'gantogram-vertical-line': !_vm.$vuetify.theme.dark,
				'gantogram-vertical-line-dark-theme': _vm.$vuetify.theme.dark,
			},style:({
				top: _vm.headerHeight + 'px',
				left: _vm.getLeftForDate(date) + _vm.dayWidth - 1 + 'px',
				height: _vm.totalHeight - _vm.headerHeight + 'px',
			})})}),_vm._l((_vm.events),function(event,key){return _c('div',{key:'event' + key,staticClass:"gantogram-event",style:({
				'line-height': _vm.eventHeight + 'px',
				'height': _vm.eventHeight - 6 + 'px',
				'top': _vm.locations.events['event' + key].top + 3 + 'px',
				'left': _vm.locations.events['event' + key].left + 3 + 'px',
				'width': _vm.locations.events['event' + key].width - 6 + 'px',
				'background': event.background,
				'color': event.color,
				'display': _vm.locations.events['event' + key].display,
			}),attrs:{"title":event.title},domProps:{"innerHTML":_vm._s(event.html)},on:{"click":function($event){return _vm.eventClicked(event)}}})}),_vm._l((_vm.dates),function(date,key){return _c('div',{key:date,class:{
				'gantogram-header-item': !_vm.$vuetify.theme.dark && true,
				'gantogram-header-item-dark-theme': _vm.$vuetify.theme.dark && true,
				'gantogram-header-item-last': key === _vm.dates.length - 1,
			},style:({
				'line-height': _vm.headerHeight + 'px',
				'height': _vm.headerHeight + 'px',
				'width': _vm.dayWidth + 'px',
				'left': _vm.getLeftForDate(date) + 'px',
				'top': _vm.headerTop + 'px',
			})},[_vm._v("\n\t\t\t"+_vm._s(_vm.reformatHeader(date))+"\n\t\t")])}),_vm._l((_vm.rows),function(row,key){return _c('div',{key:'row' + key,class:{
				'gantogram-sidebar-item': !_vm.$vuetify.theme.dark && true,
				'gantogram-sidebar-item-dark-theme': _vm.$vuetify.theme.dark && true,
				'gantogram-sidebar-item-last': key === _vm.rows.length - 1 && !_vm.$vuetify.theme.dark,
				'gantogram-sidebar-item-last-dark-theme': key === _vm.rows.length - 1 && _vm.$vuetify.theme.dark,
			},style:({
				'top': _vm.locations.rows['row' + key].top + 'px',
				'left': _vm.sidebarLeft + 'px',
				'line-height': _vm.eventHeight + 'px',
				'height': _vm.locations.rows['row' + key].size * _vm.eventHeight + 'px',
				'width': _vm.sidebarWidth + 'px',
			})},[_vm._v("\n\t\t\t"+_vm._s(row)+"\n\t\t")])}),_c('div',{class:{
				'gantogram-corner': !_vm.$vuetify.theme.dark,
				'gantogram-corner-dark-theme': _vm.$vuetify.theme.dark,
			},style:({
				top: _vm.headerTop + 'px',
				left: _vm.sidebarLeft + 'px',
				height: _vm.headerHeight + 'px',
				width: _vm.sidebarWidth + 'px',
			})})],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }